import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'src/app-redux/rtkq.interceptor';
import { transformResponses } from 'src/app-redux/rtkq.interceptor';
import { apiResources } from 'src/common/Constants';
import { PushNotification, UpdateNotificationRequestDto } from 'src/common/Notification';

const notificationsTag = 'notifications';

/** RTK Query API slice for notification endpoints. */
export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  tagTypes: [notificationsTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    /** Query to fetch all notifications. */
    fetchNotifications: builder.query<Array<PushNotification>, void>({
      providesTags: [notificationsTag],
      query: () => apiResources.notifications,
      ...transformResponses,
    }),
    /** Mutation to mark all notifications as read. */
    markAllNotificationsAsRead: builder.mutation<{ data: { data: boolean; status: boolean } }, void>({
      query: () => ({ url: apiResources.notificationsMarkAllRead, method: 'POST' }),
      invalidatesTags: [notificationsTag],
    }),
    /** Mutation to mark a single notification as read. */
    readNotification: builder.mutation<void, UpdateNotificationRequestDto>({
      query: (body) => ({ url: apiResources.notificationsRead, method: 'POST', body }),
      invalidatesTags: [notificationsTag],
    }),
  }),
});

/** RTK Query hooks for notification endpoints. */
export const { useFetchNotificationsQuery, useMarkAllNotificationsAsReadMutation, useReadNotificationMutation } =
  notificationsApi;
